module.exports = __webpack_public_path__ + "static/media/addphoto.8d470781.png";